import React, { useEffect } from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { fetchDataByQuery } from "../../../service/dataExport";
import Select from "react-select";
import { documentStudentExportColumn } from "../../../static/staticQuery.";

const DocumentTables = ({
  allDocumentData = {},
  coordinatorData,
  docWiseData,
  allReportLoading = false,
  cordinateLoading = false,
  docLoading = false,
  docRatioData,
  docRatioLoading,
  cordinatorDocData,
  cordinatorDocLoading,
  monthData,
  monthDataLoading,
  setYearState,
  cordinatorList,
  setCounseleorName,
  intakeData,
  intakeDataLoading,
}) => {
  const hasData =
    allDocumentData &&
    typeof allDocumentData === "object" &&
    Object.keys(allDocumentData).length > 0;
  const hasDocRatioData =
    docRatioData &&
    typeof docRatioData === "object" &&
    Object.keys(docRatioData).length > 0;
  const hasCoordinatorData = coordinatorData && coordinatorData.length > 0;
  const hasMonthData = monthData && monthData.length > 0;
  const hasDocData = docWiseData && docWiseData.length > 0;
  const hasIntakeData = intakeData && intakeData.length > 0;
  const hasCordinatorDocData =
    cordinatorDocData && cordinatorDocData.length > 0;
  const colData =
    `s.StdId AS 'Student Id', s.Counsellorname AS 'Coordinator name', CASE WHEN s.ststatus = 0 THEN 'Active' WHEN s.ststatus = 1 THEN 'HOLD' WHEN s.ststatus = 2 THEN 'DROP' WHEN s.ststatus = 3 THEN 'Alumni' WHEN s.ststatus = 4 THEN 'InActive' WHEN s.ststatus = 5 THEN 'Admission Deffered' WHEN s.ststatus = 6 THEN 'Deffered Active' WHEN s.ststatus = 7 THEN 'Ref/VIP' ELSE 'Unknown' END AS Status, d.docname AS 'Document Name', sd.filename AS 'File Name', sd.AppvDate AS 'Approval Date', sd.Appvuser AS 'Approved By', sd.AddDate AS 'Add Date', sd.status, CASE WHEN d.mandatory = 1 THEN 'Yes' WHEN d.mandatory = 2 THEN 'No' ELSE 'NA' END AS Mandatory`;
  let cordinatorOptions = [];
  if (cordinatorList?.length > 0) {
    cordinatorOptions = cordinatorList?.map((item) => ({
      label: item?.COUNSELOR,
      value: item?.COUNSELOR,
    }));
  }

  useEffect(()=>{
    console.log(monthData)
  },[])


  return (
    <div className="w-100">
      {!allReportLoading && !docRatioLoading ? (
        <div className="card mb-3">
          <div className="card-body">
            <div>
              <div className=" bg-transparent mb-2">
                <span className="fs-5 fw-bold text-dark">
                  All Documents Reports
                </span>
              </div>
              <div className="overflow-auto wb-scrollbar-w-1 mb-3">
                {hasData ? (
                  <table className="table table-yesgermany table-bordered">
                    <thead>
                      {/* <tr>
                        <th
                          colSpan={3}
                          className="text-center text-secondary outline-info"
                        >
                          Unique Student Count
                        </th>
                        <th
                          colSpan={8}
                          className="text-center text-secondary outline-success"
                        >
                          Documents Count
                        </th>
                      </tr> */}
                      <tr className="text-nowrap">
                        <th>Total Students</th>
                        <th>Checklist Not Added </th>
                        <th>Checklist Added</th>
                        <th>Documents Needed</th>
                        <th>Documents Not Uploaded</th>
                        <th>Documents Uploaded</th>
                        <th>Documents Approved</th>
                        <th>Approved (with in TAT)</th>
                        <th>Approved (out of TAT)</th>
                        <th>Pending for Approval</th>
                        <th>Documents Rejected</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="text-center">
                        {/* allStudents */}
                        <td
                          className="cursor-pointer"
                          onClick={() =>
                            fetchDataByQuery(
                              allDocumentData.allStudents?.query,
                              documentStudentExportColumn,
                              "Confirm to download .csv file"
                            )
                          }
                        >
                          {allDocumentData.allStudents?.count || 0}
                        </td>
                        {/* check list not added */}
                        <td
                          className="cursor-pointer"
                          onClick={() =>
                            fetchDataByQuery(
                              allDocumentData.checkListNotAdded?.query,
                              documentStudentExportColumn,
                              "Confirm to download .csv file"
                            )
                          }
                        >
                          {allDocumentData.checkListNotAdded?.count || 0}
                        </td>

                        {/* check list added */}
                        <td
                          className="cursor-pointer"
                          onClick={() =>
                            fetchDataByQuery(
                              allDocumentData.checkListAdded?.query,
                              documentStudentExportColumn,
                              "Confirm to download .csv file"
                            )
                          }
                        >
                          {allDocumentData.checkListAdded?.count || 0}
                        </td>

                        {/* totalDocuments needed */}
                        <td
                          className="cursor-pointer"
                          onClick={() =>
                            fetchDataByQuery(
                              allDocumentData.totalDocAdded?.query,
                              documentStudentExportColumn,
                              "Confirm to download .csv file"
                            )
                          }
                        >
                          {allDocumentData.totalDocAdded?.count || 0}
                        </td>
                        {/* pendingDocuments */}
                        <td
                          className="cursor-pointer"
                          onClick={() =>
                            fetchDataByQuery(
                              allDocumentData.notUploadedDocuments?.query,
                              documentStudentExportColumn,
                              "Confirm to download .csv file"
                            )
                          }
                        >
                          {allDocumentData.notUploadedDocuments?.count || 0}
                        </td>

                        {/* uploadedDocuments */}
                        <td
                          className="cursor-pointer"
                          onClick={() =>
                            fetchDataByQuery(
                              allDocumentData.uploadedDocuments?.query,
                              documentStudentExportColumn,
                              "Confirm to download .csv file"
                            )
                          }
                        >
                          {allDocumentData.uploadedDocuments?.count || 0}
                        </td>

                        {/* approvedDocuments */}
                        <td
                          className="cursor-pointer"
                          onClick={() =>
                            fetchDataByQuery(
                              allDocumentData.approvedDocuments?.query,
                              documentStudentExportColumn,
                              "Confirm to download .csv file"
                            )
                          }
                        >
                          {allDocumentData.approvedDocuments?.count || 0}
                        </td>

                        {/* withInTat */}
                        <td
                          className="cursor-pointer"
                          onClick={() =>
                            fetchDataByQuery(
                              allDocumentData.withInTat?.query,
                              documentStudentExportColumn,
                              "Confirm to download .csv file"
                            )
                          }
                        >
                          {allDocumentData.withInTat?.count || 0}
                        </td>

                        {/* withOutTat */}
                        <td
                          className="cursor-pointer"
                          onClick={() =>
                            fetchDataByQuery(
                              allDocumentData.withOutTat?.query,
                              documentStudentExportColumn,
                              "Confirm to download .csv file"
                            )
                          }
                        >
                          {allDocumentData.withOutTat?.count || 0}
                        </td>

                        {/* apprPendingDocuments */}
                        <td
                          className="cursor-pointer"
                          onClick={() =>
                            fetchDataByQuery(
                              allDocumentData.apprPendingDocuments?.query,
                              documentStudentExportColumn,
                              "Confirm to download .csv file"
                            )
                          }
                        >
                          {allDocumentData.apprPendingDocuments?.count || 0}
                        </td>
                        {/* rejectedDocuments */}
                        <td
                          className="cursor-pointer"
                          onClick={() =>
                            fetchDataByQuery(
                              allDocumentData.rejectedDocuments?.query,
                              documentStudentExportColumn,
                              "Confirm to download .csv file"
                            )
                          }
                        >
                          {allDocumentData.rejectedDocuments?.count || 0}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                ) : (
                  <p>No data available.</p>
                )}
              </div>
            </div>
            <div className="">
              <div className="">
                <span className="fs-5 fw-bold text-dark">
                  Document Uploaded Ratio
                </span>
              </div>
              <div className="py-2">
                {hasDocRatioData ? (
                  <table className="table table-yesgermany table-bordered">
                    <thead className="">
                      <tr className="text-center">
                        <th>0 - 10%</th>
                        <th>10% - 30%</th>
                        <th>30% - 50%</th>
                        <th>50% - 75%</th>
                        <th>75% - 90%</th>
                        <th>90% - 100%</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="text-center">
                        <td>{docRatioData?.lessthan10}</td>
                        <td>{docRatioData?.lessthan30}</td>
                        <td>{docRatioData?.lessthan50}</td>
                        <td>{docRatioData?.lessthan75}</td>
                        <td>{docRatioData?.lessthan90}</td>
                        <td>{docRatioData?.full}</td>
                      </tr>
                    </tbody>
                  </table>
                ) : (
                  <p>No Data to Display</p>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="py-3">
          <SkeletonTheme highlightColor="#fff3cd">
            <Skeleton height={70} style={{ marginBottom: "10px" }} />
          </SkeletonTheme>
        </div>
      )}

      <div className="card mb-3">
        <div className="card-body">
          <div>
            <div className="row mb-2">
              <div className="col-6">
                <span className="fs-5 fw-bold text-dark">
                  Month's Wise Reports
                </span>
              </div>
            </div>
            {!monthDataLoading ? (
              <div className="overflow-hidden">
                {hasMonthData ? (
                  <table className="table table-yesgermany table-bordered">
                    <thead className="">
                      <tr className="text-nowrap">
                        <th>Month</th>
                        <th>Total Students</th>
                        <th>Checklist Not Added</th>
                        <th>Checklist Added</th>
                        <th>Document Needed</th>
                        <th>Uploaded Documents</th>
                        <th>Approved</th>
                        <th>Approved (with in TAT)</th>
                        <th>Approved (with out TAT)</th>
                        <th>Rejected</th>
                        <th>Document Not Uploaded</th>
                        <th>Pending for Approval</th>
                      </tr>
                    </thead>
                    <tbody>
                      {monthData?.map(({ month, details }, index) => (
                        <tr key={index} className="text-center text-nowrap">
                          <td className="text-start">{month}</td>
                          <td
                            className="cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                details.allStudents?.query,
                                colData,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {details.allStudents?.count || 0}
                          </td>

                          <td
                            className="cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                details.checkListNotAdded?.query,
                                colData,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {details.checkListNotAdded?.count || 0}
                          </td>

                          <td
                            className="cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                details.checkListAdded?.query,
                                colData,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {details.checkListAdded?.count || 0}
                          </td>

                          <td
                            className="cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                details.totalDocAdded?.query,
                                colData,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {details.totalDocAdded?.count || 0}
                          </td>
                          <td
                            className="cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                details.uploadedDocuments?.query,
                                colData,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {details.uploadedDocuments?.count || 0}
                          </td>
                          <td
                            className="cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                details.approvedDocuments?.query,
                                colData,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {details.approvedDocuments?.count || 0}
                          </td>
                          <td
                            className="cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                details.withInTat?.query,
                                colData,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {details.withInTat?.count || 0}
                          </td>
                          <td
                            className="cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                details.withOutTat?.query,
                                colData,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {details.withOutTat?.count || 0}
                          </td>
                          <td
                            className="cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                details.rejectedDocuments?.query,
                                colData,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {details.rejectedDocuments?.count || 0}
                          </td>
                          <td
                            className="cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                details.pendingDocuments?.query,
                                colData,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {details.pendingDocuments?.count || 0}
                          </td>
                          <td
                            className="cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                details.apprPendingDocuments?.query,
                                colData,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {details.apprPendingDocuments?.count || 0}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <p>No Data to Display</p>
                )}
              </div>
            ) : (
              <div className="py-3">
                <SkeletonTheme highlightColor="#fff3cd">
                  <Skeleton height={70} style={{ marginBottom: "10px" }} />
                </SkeletonTheme>
              </div>
            )}
          </div>
        </div>
      </div>

      {!cordinateLoading && !cordinatorDocLoading ? (
        <div className="card mb-3">
          <div className="card-body">
            <div className="mb-2">
              <div className="">
                <span className="fs-5 fw-bold text-dark">
                  Coordinator's Wise Reports
                </span>
              </div>
              <div className="py-2 overflow-auto wb-scrollbar-w-1">
                {hasCoordinatorData ? (
                  <table className="table table-yesgermany table-bordered">
                    <thead className="text-nowrap">
                      <tr>
                        <th>Coordinator</th>
                        <th>Total Students</th>
                        <th>Checklist Not Added</th>
                        <th>Checklist Added</th>
                        <th>Document Not Uploaded</th>
                        <th>Document Needed</th>
                        <th>Uploaded Documents</th>
                        <th>Approved</th>
                        <th>Approved (with in TAT)</th>
                        <th>Approved (with out TAT)</th>
                        <th>Rejected</th>
                        <th>Pending for Approval</th>
                      </tr>
                    </thead>
                    <tbody>
                      {coordinatorData?.map(
                        ({ coordinator, details }, index) => (
                          <tr key={index} className="text-center">
                            <td className="text-start">{coordinator}</td>
                            {/* total students */}
                            <td
                              className="cursor-pointer"
                              onClick={() =>
                                fetchDataByQuery(
                                  details.allStudents?.query,
                                  colData,
                                  "Confirm to download .csv file"
                                )
                              }
                            >
                              {details.allStudents?.count || 0}
                            </td>

                            {/* checklist not added */}
                            <td
                              className="cursor-pointer"
                              onClick={() =>
                                fetchDataByQuery(
                                  details.checkListNotAdded?.query,
                                  colData,
                                  "Confirm to download .csv file"
                                )
                              }
                            >
                              {details.checkListNotAdded?.count || 0}
                            </td>

                            {/* checklist added */}
                            <td
                              className="cursor-pointer"
                              onClick={() =>
                                fetchDataByQuery(
                                  details.checkListAdded?.query,
                                  colData,
                                  "Confirm to download .csv file"
                                )
                              }
                            >
                              {details.checkListAdded?.count || 0}
                            </td>

                            {/* not uploaded */}
                            <td
                              className="cursor-pointer"
                              onClick={() =>
                                fetchDataByQuery(
                                  details.notUploadedDocuments?.query,
                                  colData,
                                  "Confirm to download .csv file"
                                )
                              }
                            >
                              {details.notUploadedDocuments?.count || 0}
                            </td>

                            {/* document needed */}
                            <td
                              className="cursor-pointer"
                              onClick={() =>
                                fetchDataByQuery(
                                  details.totalDocAdded?.query,
                                  colData,
                                  "Confirm to download .csv file"
                                )
                              }
                            >
                              {details.totalDocAdded?.count || 0}
                            </td>

                            {/* document uploaded */}
                            <td
                              className="cursor-pointer"
                              onClick={() =>
                                fetchDataByQuery(
                                  details.uploadedDocuments?.query,
                                  colData,
                                  "Confirm to download .csv file"
                                )
                              }
                            >
                              {details.uploadedDocuments?.count || 0}
                            </td>

                            {/* approved document */}
                            <td
                              className="cursor-pointer"
                              onClick={() =>
                                fetchDataByQuery(
                                  details.approvedDocuments?.query,
                                  colData,
                                  "Confirm to download .csv file"
                                )
                              }
                            >
                              {details.approvedDocuments?.count || 0}
                            </td>

                            {/* with in tat */}
                            <td
                              className="cursor-pointer"
                              onClick={() =>
                                fetchDataByQuery(
                                  details.withInTat?.query,
                                  colData,
                                  "Confirm to download .csv file"
                                )
                              }
                            >
                              {details.withInTat?.count || 0}
                            </td>

                            {/* out of tat */}
                            <td
                              className="cursor-pointer"
                              onClick={() =>
                                fetchDataByQuery(
                                  details.withOutTat?.query,
                                  colData,
                                  "Confirm to download .csv file"
                                )
                              }
                            >
                              {details.withOutTat?.count || 0}
                            </td>

                            {/* document rejected */}
                            <td
                              className="cursor-pointer"
                              onClick={() =>
                                fetchDataByQuery(
                                  details.rejectedDocuments?.query,
                                  colData,
                                  "Confirm to download .csv file"
                                )
                              }
                            >
                              {details.rejectedDocuments?.count || 0}
                            </td>

                            <td
                              className="cursor-pointer"
                              onClick={() =>
                                fetchDataByQuery(
                                  details.apprPendingDocuments?.query,
                                  colData,
                                  "Confirm to download .csv file"
                                )
                              }
                            >
                              {details.apprPendingDocuments?.count || 0}
                            </td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </table>
                ) : (
                  <p>No Data to Display</p>
                )}
              </div>
            </div>
            <div className="">
              <div className="">
                <span className="fs-5 fw-bold text-dark">
                  Document Uploaded Ratio
                </span>
              </div>
              <div className="py-2">
                {hasCordinatorDocData ? (
                  <table className="table table-yesgermany table-bordered">
                    <thead className="">
                      <tr>
                        <th>Cordinator</th>
                        <th>0</th>
                        <th>1% - 10%</th>
                        <th>10% - 30%</th>
                        <th>30% - 50%</th>
                        <th>50% - 75%</th>
                        <th>75% - 90%</th>
                        <th>90% - 100%</th>
                      </tr>
                    </thead>
                    <tbody>
                      {cordinatorDocData?.map((item, idx) => (
                        <tr key={idx}>
                          <td>{item.coordinator}</td>
                          <td>{item?.counts?.zero}</td>
                          <td>{item?.counts?.lessthan10}</td>
                          <td>{item?.counts?.lessthan30}</td>
                          <td>{item?.counts?.lessthan50}</td>
                          <td>{item?.counts?.lessthan75}</td>
                          <td>{item?.counts?.lessthan90}</td>
                          <td>{item?.counts?.full}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <p>No Data to Display</p>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="py-3">
          <SkeletonTheme highlightColor="#fff3cd">
            <Skeleton height={70} style={{ marginBottom: "10px" }} />
          </SkeletonTheme>
        </div>
      )}

      {!intakeDataLoading ? (
        <div className="card mb-3">
          <div className="card-body">
            <div className="mb-2">
              <div className="">
                <span className="fs-5 fw-bold text-dark">
                  Intake Wise Reports
                </span>
              </div>
              <div
                className="py-2 overflow-auto wb-scrollbar-w-1"
                style={{ maxHeight: "50vh" }}
              >
                {hasIntakeData ? (
                  <table className="table table-yesgermany table-bordered">
                    <thead className="text-nowrap">
                      <tr>
                        <th>Intake</th>
                        <th>Total Students</th>
                        <th>Checklist Not Added</th>
                        <th>Checklist Added</th>
                        <th>Document Needed</th>
                        <th>Uploaded Documents</th>
                        <th>Approved</th>
                        <th>Approved (with in TAT)</th>
                        <th>Approved (with out TAT)</th>
                        <th>Rejected</th>
                        <th>Document Not Uploaded</th>
                        <th>Pending for Approval</th>
                      </tr>
                    </thead>
                    <tbody>
                      {intakeData?.map(({ intake, details }, index) => (
                        <tr key={index} className="text-center">
                          <td className="text-start">{intake}</td>
                          {/* total students */}
                          <td
                            className="cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                details.allStudents?.query,
                                colData,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {details.allStudents?.count || 0}
                          </td>

                          {/* checklist not added */}
                          <td
                            className="cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                details.checkListNotAdded?.query,
                                colData,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {details.checkListNotAdded?.count || 0}
                          </td>

                          {/* checklist added */}
                          <td
                            className="cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                details.checkListAdded?.query,
                                colData,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {details.checkListAdded?.count || 0}
                          </td>

                          {/* document needed */}
                          <td
                            className="cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                details.totalDocAdded?.query,
                                colData,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {details.totalDocAdded?.count || 0}
                          </td>

                          {/* document uploaded */}
                          <td
                            className="cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                details.uploadedDocuments?.query,
                                colData,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {details.uploadedDocuments?.count || 0}
                          </td>

                          {/* approved document */}
                          <td
                            className="cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                details.approvedDocuments?.query,
                                colData,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {details.approvedDocuments?.count || 0}
                          </td>

                          {/* with in tat */}
                          <td
                            className="cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                details.withInTat?.query,
                                colData,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {details.withInTat?.count || 0}
                          </td>

                          {/* out of tat */}
                          <td
                            className="cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                details.withOutTat?.query,
                                colData,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {details.withOutTat?.count || 0}
                          </td>

                          {/* document rejected */}
                          <td
                            className="cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                details.rejectedDocuments?.query,
                                colData,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {details.rejectedDocuments?.count || 0}
                          </td>

                          {/* not uploaded */}
                          <td
                            className="cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                details.notUploadedDocuments?.query,
                                colData,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {details.notUploadedDocuments?.count || 0}
                          </td>
                          <td
                            className="cursor-pointer"
                            onClick={() =>
                              fetchDataByQuery(
                                details.apprPendingDocuments?.query,
                                colData,
                                "Confirm to download .csv file"
                              )
                            }
                          >
                            {details.apprPendingDocuments?.count || 0}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <p>No Data to Display</p>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="py-3">
          <SkeletonTheme highlightColor="#fff3cd">
            <Skeleton height={70} style={{ marginBottom: "10px" }} />
          </SkeletonTheme>
        </div>
      )}

      {!docLoading ? (
        <div className="card mb-3">
          <div className="card-body">
            <div className="">
              <span className="fs-5 fw-bold text-dark">
                Document's Wise Reports
              </span>
            </div>
            <div className="py-2 overflow-auto wb-scrollbar-w-1">
              {hasDocData ? (
                <table className="table table-yesgermany table-bordered">
                  <thead className="text-nowrap">
                    <tr>
                      <th>Document Name</th>
                      <th>Total Students</th>
                      <th>Documents Uploaded</th>
                      <th>Documents Upload Pending</th>
                      <th>Documents Approved</th>
                      <th>Documents Rejected</th>
                      <th>Documents Approval Pending</th>
                    </tr>
                  </thead>
                  <tbody>
                    {docWiseData?.map(({ docname, details }, index) => (
                      <tr key={index} className="text-nowrap">
                        <td>{docname}</td>
                        <td
                          className="cursor-pointer"
                          onClick={() =>
                            fetchDataByQuery(
                              details.totalStudents?.query,
                              colData,
                              "Confirm to download .csv file"
                            )
                          }
                        >
                          {details.totalStudents?.count}
                        </td>

                        <td
                          className="cursor-pointer"
                          onClick={() =>
                            fetchDataByQuery(
                              details.docUploaded?.query,
                              colData,
                              "Confirm to download .csv file"
                            )
                          }
                        >
                          {details.docUploaded?.count}
                        </td>

                        <td
                          className="cursor-pointer"
                          onClick={() =>
                            fetchDataByQuery(
                              details.docNotUploaded?.query,
                              colData,
                              "Confirm to download .csv file"
                            )
                          }
                        >
                          {details.docNotUploaded?.count}
                        </td>

                        <td
                          className="cursor-pointer"
                          onClick={() =>
                            fetchDataByQuery(
                              details.docApproved?.query,
                              colData,
                              "Confirm to download .csv file"
                            )
                          }
                        >
                          {details.docApproved?.count}
                        </td>

                        <td
                          className="cursor-pointer"
                          onClick={() =>
                            fetchDataByQuery(
                              details.docRejected?.query,
                              colData,
                              "Confirm to download .csv file"
                            )
                          }
                        >
                          {details.docRejected?.count || 0}
                        </td>

                        <td
                          className="cursor-pointer"
                          onClick={() =>
                            fetchDataByQuery(
                              details.apprPendingDocuments?.query,
                              colData,
                              "Confirm to download .csv file"
                            )
                          }
                        >
                          {details.apprPendingDocuments?.count}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <p>No Data to Display</p>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className="py-3">
          <SkeletonTheme highlightColor="#fff3cd">
            <Skeleton height={70} style={{ marginBottom: "10px" }} />
          </SkeletonTheme>
        </div>
      )}
    </div>
  );
};

export default DocumentTables;
